import { Combobox } from "@/components/ui/combobox";
import { useListOnboardingCustomerInstances, type AvailableOnboardingInstanceInfo } from "@/lib/api/customer";
import { onboardingCustomerName } from "../onboardingPrefill";

/** One "New Client" onboarding instance no customer has used yet, picked like ManageCustomers' onboarding instance. */
export function OnboardingInstanceSelect({
  id,
  value,
  onChange,
  disabled,
}: {
  id: string;
  value: string;
  onChange: (instance: AvailableOnboardingInstanceInfo | null) => void;
  disabled: boolean;
}) {
  const instancesResult = useListOnboardingCustomerInstances();
  const instances: AvailableOnboardingInstanceInfo[] = instancesResult.data?.success ? instancesResult.data.data : [];
  const options = instances.map((instance) => ({
    value: instance.id,
    label: onboardingCustomerName(instance) ?? instance.template.name,
  }));
  const failedToLoad = instancesResult.isError || instancesResult.data?.success === false;

  return (
    <div className="space-y-1">
      <Combobox
        id={id}
        isModal
        dwimOnChange
        virtualizeList
        popoverClassName='md:min-w-[300px] lg:min-w-[400px] xl:min-w-[500px]'
        className="w-full"
        placeholder={instancesResult.isLoading ? "Loading onboarding instances…" : "None"}
        options={options}
        value={value}
        onValueChange={(instanceId: string) => onChange(instances.find((instance) => instance.id === instanceId) ?? null)}
        disabled={disabled}
      />
      {failedToLoad && <p className="text-xs text-red-600">Couldn't load the onboarding instances.</p>}
    </div>
  );
}
